module.exports = __webpack_public_path__ + "img/jingao.313c88f1.png";